import React from 'react'
import ReactSwitch from 'react-switch'
import settings from 'settings'

import { Button } from '@hackedu/react-components'

import Loader from '../Loader'
import Statistics from '../Statistics'
import FormatedMinutes from '../FormatedMinutes'
import Tabs from '../Tabs'
import UsersDetail from './UsersDetail'
import Icon from '../Icon'

class AsssessmentDetail extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    if (this.props.loadingAssessmentDetails) {
      return <Loader visible text="Loading..." />
    }
    const { assessmentDetail, assessment } = this.props
    const totalAssessments = (assessmentDetail.hacker_stats || {}).total_hackers || 0
    const totalCompleted = (assessmentDetail.hacker_stats || {}).total_hackers_completed || 0
    return (
      <>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            marginTop: 40,
          }}
        >
          <Statistics
            noMargin
            header={(
              <span
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginLeft: 10,
                }}
              >
                {`${(((totalCompleted / totalAssessments) * 100) || 0).toFixed(0)}`}
                <span style={{ fontSize: 22 }}>%</span>
              </span>
            )}
            content={`${totalCompleted} of ${totalAssessments} users`}
            detail="Completed Assessment"
          />
          <Statistics
            header={(
              <FormatedMinutes
                minutes={assessmentDetail.total_time_assessment / 60}
              />
            )}
            content={(
              <FormatedMinutes
                minutes={(assessmentDetail.total_time_assessment / 60) / (assessmentDetail.assessments_stats || {}).total_assessments_assigned}
                isText
                extraText="per user"
              />
            )}
            detail="Time Spent"
          />
          <Statistics
            noMargin
            header={(assessmentDetail.hacker_stats || {}).total_code_submissions || 0}
            content={`${(((assessmentDetail.hacker_stats || {}).total_code_submissions || 0) / ((assessmentDetail.hacker_stats || {}).total_hackers || 0) || 0).toFixed(0)} per user`}
            detail="Code Submissions"
          />
        </div>
        <br />
        <div
          data-uk-grid=""
        >
          <div
            className="uk-width-1-1"
          >
            <Tabs
              noMargin
              id="assessment-detail-modal-tabs"
              tabs={[{
                key: 'assessment-detail-modal-tab-content',
                title: 'Content',
                component: this.props.lockContent ? this.props.renderLockMessage('uk-margin-large-top') : (
                  <>
                    <table
                      className="uk-table uk-table-divider uk-table-small uk-table-middle"
                    >
                      <thead>
                        <tr>
                          <th>Title</th>
                          <th className="uk-text-center">Completed By</th>
                          <th className="uk-text-center">Average Score</th>
                        </tr>
                      </thead>
                      <tbody className="uk-text-small">
                        {(assessmentDetail.hacker_stats ? assessmentDetail.content : assessment.content).map((content, i) => (
                          <tr key={`${content.content_uuid}-${i}`}>
                            <td>
                              {`${content.title}`}
                              <br />
                              <span
                                className="uk-text-secondary"
                              >
                                {`${settings.engines[content.language.name || content.language]} / ${settings.frameworks[content.framework.name || content.framework]}`}
                                &nbsp;
                                &nbsp;
                                {`(${settings.apps[content.app]})`}
                              </span>
                            </td>
                            <td className="uk-text-center">{content.total ? `${parseInt((content.completed / content.total) * 100, 10)} %` : ' - '}</td>
                            <td className="uk-text-center">{content.avg ? `${content.avg} / ${content.points} ` : ' - '}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ),
              }, {
                key: 'assessment-detail-modal-tab-users',
                title: 'Users',
                component: this.props.lockContent ? this.props.renderLockMessage('uk-margin-large-top') : (
                  <UsersDetail
                    assessmentDetail={assessmentDetail}
                  />
                ),
              }, {
                key: 'assessment-detail-modal-settings-users',
                title: 'Settings',
                component: (
                  <div
                    className="uk-width-1-1 uk-padding-top uk-flex uk-flex-column uk-flex-left"
                  >
                    <p>If "Allow Hints" option is active users assigned to this assessment will be able to use them.</p>
                    <div
                      className="uk-inline uk-flex uk-flex-middle uk-flex-left"
                      style={{
                        width: 200,
                      }}
                      data-uk-tooltip={!assessment.editable ? 'Can\'t edit because some users had already started this assessment.' : null}
                    >
                      <ReactSwitch
                        width={48}
                        height={24}
                        onChange={() => {
                          this.props.createOrUpdateAssessment(
                            assessment.uuid,
                            this.props.match.params.organization_uuid,
                            null,
                            null,
                            !assessment.hints_active,
                            null,
                            null,
                            () => this.props.onUpdate({
                              assessment: {
                                ...assessment,
                                hints_active: !assessment.hints_active,
                              },
                            }),
                          )
                        }}
                        checked={assessment.hints_active}
                        disabled={!assessment.editable}
                        id="normal-switch"
                        offColor="#999999"
                        onColor="#1e87f0"
                        checkedIcon={false}
                        uncheckedIcon={false}
                      />
                      <span style={{ paddingLeft: 10 }}>
                        Allow hints
                      </span>
                    </div>
                    {/* <Button 
                      content="Delete"
                      onClick={() => { this.props.showDeleteAssessmentModal(assessment) }}
                      danger
                    /> */}
                    <button
                      style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '200px',
                        marginTop: 20,
                      }}
                      className="uk-button uk-button-danger"
                    >
                      <Icon
                        name="delete-bin"
                        style={{
                          position: 'absolute',
                          left: 10,
                        }}
                      />
                      Delete Assessment
                    </button>
                  </div>
                ),
              }]}
            />
          </div>
        </div>
        <br />
        <br />
        <br />
      </>
    )
  }
}

export default AsssessmentDetail
